<div class="layout-topbar">
	<div class="layout-topbar-wrapper">
		<div class="layout-topbar-right">
			<div class="text-xl font-bold" [class]="dynamicTitle" *ngIf="!onExtendedMobile()">
				{{ titleId | translate }}
			</div>

			<div *ngIf="onExtendedMobile()" class="flex pr-3">
				<img
					[src]="getMenuTheme() === 'dim' ? 'assets/images/logos/CAME-A_alpha.png' : 'assets/images/logos/CAME-A_alpha.png'"
					alt="Logo" style="height:1.5rem;" />
			</div>

			<ul class="layout-topbar-actions">
				<!--<p-toggleButton [(ngModel)]="enableBeta" class="mx-3"//TOREMOVE in futuro
					[onLabel]="onExtendedMobile() ? ('BETA' | translate) : ('BETA_ACTIVE' | translate)"
					[offLabel]="onExtendedMobile() ? ('BETA' | translate) : ('BETA_DISACTIVE' | translate)"
					[pTooltip]="enableBeta ? ('DISABLING_BETA' | translate) : ('ABILITY_BETA' | translate)"
					tooltipEvent="hover" tooltipPosition="bottom" (click)="goToOldCameConnect()" />-->
				<button *ngIf="iconNotificationMaintenance()" icon="pi cm-mail text-3xl" id="btn-topbar-user-maintenance"
					pButton pRipple class="p-button-primary p-button-text hover:surface-400 text-color mb-2 mx-2"
					(click)="viewNotificationMaintenance()">
				</button>

				<li #notifications class="topbar-item notifications"
					[ngClass]="{'active-topmenuitem':homeMain.activeTopbarItem === notifications}">
					<button pButton pRipple id="btn-notification-list"
						class="p-button-primary p-button-text hover:surface-400 text-color shadow-none border-round-xl"
						(click)="homeMain.onTopbarItemClick($event, notifications)">
						<span class="flex flex-row">
							<i class="pi text-3xl cm-bell"></i>
							<p-badge [value]="notificationList.length < 100 ? notificationList.length.toString() : '99+'" class="absolute top-0"
								styleClass="p-badge-topbar text-sm pt-0 ml-0" [class]="notificationList.length < 100 ? 'ml-2' : 'ml-0'"
								[severity]="thereIsDangerNotification() ? 'danger': 'info'">
							</p-badge>
						</span>
					</button>
					<ul id="notificationList" class="fadeInDown border-round-xl">
						<li class="flex justify-content-between cursor-auto hover:surface-900 pb-1">
							<span class="font-medium flex align-items-center">{{ "NOTIFICATIONS" | translate }}</span>
							<div class="flex flex-row align-items-center">
								<p-tag [value]="notificationList.length < 100 ? notificationList.length.toString() : '99+'"
									severity="info" styleClass="p-tag-slim"></p-tag>
								<p-button icon="pi cm-trash"
									styleClass="p-button-text shadow-none hover:surface-400 text-color border-round-xl"
									[disabled]="notificationList.length === 0" (click)="clearMessages()"
									pTooltip="{{ 'DISMISS_ALL' | translate }}" tooltipPosition="bottom">
								</p-button>
							</div>
						</li>

						<li role="menuitem" *ngFor="let notification of notificationList let i = index" class="py-0"
							[class]="i === notificationList.length ? 'pb-2' : ''" (click)="clickNotification(i)">
							<a>
								<div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle mr-3"
									[class]="notification.background_color">
									<i class="{{notification.icon}} {{notification.color}}"></i>
								</div>
								<div class="notifications-item w-10">
									<span [class]="notification.color">{{notification.message | translate}}</span>
								</div>
							</a>
						</li>
					</ul>
				</li>

				<li #profile class="topbar-item user-profile"
					[ngClass]="{'active-topmenuitem':homeMain.activeTopbarItem === profile}">
					<button pButton pRipple id="btn-topbar-user"
						class="p-button-primary p-button-text hover:surface-400 text-color shadow-none h-full px-3 py-1 gap-3 cursor-pointer"
						(click)="homeMain.onTopbarItemClick($event,profile)">
						<i class="pi text-3xl cm-user"></i>
						<div *ngIf="showInfoAvatar" class="profile-info flex flex-column">
							<div class="text-0">{{ getCurrentRole() }}</div>
							<div class="font-semibold text-0">{{ currentUser.FirstName + ' ' + currentUser.LastName |
								truncate:[30] }}</div>
						</div>
					</button>

					<ul class="fadeInDown border-round-xl">
						<li class="layout-submenu-header border-round-top-xl cursor-auto">
							<i [class]="getMenuTheme() === 'dim' ? 'text-900' : 'text-0'" class="pi text-3xl cm-user"></i>
							<div class="profile-info">
								<h6 [class]="getMenuTheme() === 'dim' ? 'text-900' : 'text-0'">{{ currentUser.FirstName + ' ' +
									currentUser.LastName | truncate:[30] }}</h6>
								<label [class]="getMenuTheme() === 'dim' ? 'text-900' : 'text-0'">{{ currentUser.Email |
									truncate:[50] }}</label>
							</div>
						</li>
						<li role="menuitem">
							<a (click)="userProfile()">
								<i class="pi text-3xl cm-cog"></i>
								<h6>{{ 'USER_PROFILE' | translate}}</h6>
							</a>
						</li>
						<li role="menuitem" *ngIf="releaseNoteList  !== undefined && releaseNoteList.length > 0">
							<a (click)="showReleaseNote()">
								<i class="pi text-3xl cm-info"></i>
								<h6>{{ 'RELEASE_NOTE' | translate }}</h6>
							</a>
						</li>
						<!-- <li role="menuitem">
							<a (click)="showRatingDialog()">
								<i class="pi text-3xl cm-info"></i>
								<h6>{{ 'RATING_DIALOG' | translate }}</h6>
							</a>
						</li> -->

						<li role="menuitem" *ngIf="privacyNoteList  !== undefined && privacyNoteList.length > 0">
							<a (click)="showPrivacyNote()">
								<i class="pi text-3xl cm-info"></i>
								<h6>{{ 'PRIVACY_NOTE' | translate }}</h6>
							</a>
						</li>
						<li role="menuitem">
							<a href="#" (click)="logout()">
								<i class="pi text-3xl cm-logout"></i>
								<h6>{{ 'LOGOUT' | translate}}</h6>
							</a>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</div>